<div class="cx-one-ui etl-data-feed-container mx-6">
    <div class="header-container" id="header-container">
        <div class="left-title-wrapper">
            <div class="breadCrumb" (click)="onBack()" id="dataFeedBackLink" cvLocalizedText
                langSection="ETL_Data_Feed_Create" langKey="Data_Feed">Data Feed</div>
            <div class="pageTitle" *ngIf="!isEditable" cvLocalizedText langSection="ETL_Data_Feed_Create"
                langKey="New_Data_Feed">New Data Feed</div>
            <div class="pageTitle" *ngIf="isEditable && !isPreview" cvLocalizedText langSection="ETL_Data_Feed_Create"
                langKey="Edit_Data_Feed">Edit Data Feed</div>
            <div class="pageTitle" *ngIf="isPreview" cvLocalizedText langSection="ETL_Data_Feed_Create"
                langKey="View_Data_Feed">View Data Feed</div>
        </div>
        <div>
            <button class="cxone-btn btn-big btn-secondary btn-bg-is-white mr-2" (click)="onBack()"
                id="dataFeedCancelBtn" cvLocalizedText langSection="ETL_Data_Feed_Create"
                langKey="Cancel">Cancel</button>
            <button class="cxone-btn btn-big btn-secondary btn-bg-is-white mr-2" id="loadFromFileBtn" cvLocalizedText
                langSection="ETL_Data_Feed_Create" langKey="Load_From_File" (click)="openFileUpload()" *ngIf="!isPreview">Load From File</button>
            <button class="cxone-btn btn-big btn-primary btn-bg-is-white" *ngIf="!isEditable"
                (click)="createUpdateDataFeed()" [disabled]="!isFormValid || !isGridValid || invalidFieldNameFormat || isSaving" id="createDataFeedBtn"
                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Create_Button">Create</button>
            <button class="cxone-btn btn-big btn-primary btn-bg-is-white" (click)="createUpdateDataFeed()"
                [disabled]="!isFormValid || !isGridValid || invalidFieldNameFormat || disableSaveBtn || isSaving" *ngIf="isEditable && !isPreview" id="updateDataFeedBtn" cvLocalizedText
                langSection="ETL_Data_Feed_Create" langKey="Update_Button">Save and Update</button>
        </div>
    </div>
    <div class="details-container">
        <div class="cxone-data-feed-rows">
            <form>
                <div class="cxone-data-feed-row-1">
                    <div class="cxone-data-feed-col">
                        <label class="label-field allCaps" cvLocalizedText langSection="ETL_Data_Feed_Create"
                            langKey="Feed_Name">Feed Name</label>
                        <span class="required-star">*</span>
                        <div class="user-text-input" [formGroup]="feed_name">
                            <cxone-text-input id="feedName" name="feedName" textInputId="feedName" [disabled]="isEditable"
                                placeholder={{feedPlaceholder}} maxlength="50" formControlName="feedName"
                                [(ngModel)]="dataFeedName" (ngModelChange)="validateForm()" [required]="true">
                            </cxone-text-input>
                        </div>
                        <div *ngIf="(feed_name.controls['feedName'].errors
                        && (feed_name.controls['feedName'].dirty || feed_name.controls['feedName'].touched || showError)) || isFeedNameAlreadyExists">
                            <span class="error-color"
                                *ngIf="feed_name.controls['feedName'].hasError('numericPattern') && !feed_name.controls['feedName'].hasError('maxlength')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Contains_Only_Numbers">Cannot use only numbers
                            </span>
                            <span class="error-color"
                                *ngIf="feed_name.controls['feedName'].hasError('pattern') && !feed_name.controls['feedName'].hasError('maxlength')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Special_Characters">Cannot use ^
                                / ! \ \ + <> ? * & , "</span>
                            <span class="error-color"
                                *ngIf="(feed_name.controls['feedName'].hasError('duplicateName') || isFeedNameAlreadyExists) && !feed_name.controls['feedName'].hasError('numericPattern')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Name_Exists">Name already exists
                            </span>
                            <span class="error-color" *ngIf="feed_name.controls['feedName'].hasError('required')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Required_Field">This field is required
                            </span>
                            <span class="error-color" *ngIf="feed_name.controls['feedName'].hasError('maxlength')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Character_Limit">Enter up to 50 characters
                            </span>
                        </div>
                    </div>
                    <div class="cxone-data-feed-col">
                        <label class="label-field allCaps" cvLocalizedText langSection="ETL_Data_Feed_Create"
                            langKey="Source_Name">Source Name</label>
                        <span class="required-star">*</span>
                        <div class="user-text-input" [formGroup]="source_name">
                            <cxone-singleselect-dropdown id="source-name" name="sourceName" formControlName="sourceName"
                                [enableAddFreeTextItem]="true" [showFooter]="false" [options]="sourceNameList"
                                [sortKey]="'name'" [label]="'name'" [primaryKey]="'name'"
                                [placeholder]="sourcePlaceholder"
                                [(ngModel)]="selectedSource" (onCreate)="onCreateSource($event)"
                                (selectionChanged)="setSource($event)" (dropdownOpened)="dropdownOpened()"
                                [isRequired]="true">
                            </cxone-singleselect-dropdown>
                        </div>
                        <div *ngIf="source_name.controls['sourceName'].errors
                        && (source_name.controls['sourceName'].dirty || source_name.controls['sourceName'].touched || showError)">
                            <span class="error-color"
                                *ngIf="source_name.controls['sourceName'].hasError('numericPattern') && !source_name.controls['sourceName'].hasError('maxlength')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Contains_Only_Numbers">Cannot use only numbers
                            </span>
                            <span class="error-color"
                                *ngIf="source_name.controls['sourceName'].hasError('pattern') && !source_name.controls['sourceName'].hasError('maxlength')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Special_Characters">Cannot use ^
                                / ! \ \ + <> ? # & , "</span>
                            <span class="error-color"
                                *ngIf="source_name.controls['sourceName'].hasError('duplicateName') && !source_name.controls['sourceName'].hasError('numericPattern')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Name_Exists">Name already exists
                            </span>
                            <span class="error-color" *ngIf="source_name.controls['sourceName'].hasError('required')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Required_Field">This field is required
                            </span>
                            <span class="error-color" *ngIf="source_name.controls['sourceName'].hasError('maxlength')"
                                cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Character_Limit">Enter up to 50 characters
                            </span>
                        </div>
                    </div>
                </div>
            </form>
            <div class="cxone-data-feed-row-2">
                <div class="manage-fields allCaps" cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Manage_Fields">
                    Manage Fields</div>
            </div>
            <div class="cxone-data-feed-row-3">
                <hr class="separator-line">
            </div>
            <div class="cxone-data-feed-row-4">
                <div class="manage-fields-text" cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Add_Manage_Fields">
                    Add and manage fields.</div>
            </div>
            <div class="cxone-data-feed-row-5">
                <div class="fields-grid-container">
                    <div class="err-message">
                        <cxone-embedded-messages *ngIf="invalidFieldNameFormat" messageType="user-error" [messageData]="invalidFieldNameFormatMsg" id="user-error"></cxone-embedded-messages>
                        <cxone-embedded-messages *ngIf="primaryKeyNotSelected" messageType="user-error" [messageData]="primaryKeyNotSelectedMsg" id="user-error"></cxone-embedded-messages>
                    </div>
                    <cxone-omnibar [itemCountLabel]="fieldsDataRowCount" id="searchField" [isFilterable]="false"
                        (searchQueryChange)="filterGridData($event);" searchPlaceholderText={{searchPlaceholder}}
                        [searchQuery]="searchInput">
                        <cxone-omnibar-custom-content class="omnibar-custom-content-wrapper">
                            <div class="omnibar-custom-content">
                                <cxone-selected-tags></cxone-selected-tags>
                                <div class="add-field">
                                    <button *ngIf="!isPreview" class="cxone-btn btn-big btn-secondary btn-bg-is-white" id="addFieldBtn"
                                        cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Add_Field"
                                        (click)="insertNewField()" [disabled]="!allowEdit() || addButtonDisable">Add
                                        Field</button>
                                </div>
                            </div>
                        </cxone-omnibar-custom-content>
                    </cxone-omnibar>
                    <div id="manageFieldsGrid" [ngClass]="getDynamicGridClass()">
                        <cxone-grid [columnDefs]="columnDefs" [rowData]="filteredRowData" [gridOptions]="gridOptions"
                            *ngIf="isLocalizationSectionLoaded">
                        </cxone-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
